module.exports = __webpack_public_path__ + "img/OMG.2a179668.svg";